import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import LoadingIcon from "../../images/Loading_icon.gif";
import { UrlContext } from "../../contexts/UrlContext";

export default function EditProfileBasic({
  expert_id,
  expert_Name,
  expert_link,
  expert_email,
  updateProfileData,
  backupData,
  setBackupData,
}) {
  const { API_URL } = useContext(UrlContext);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);
  const [exObject, setExObject] = useState({
    expertID: "",
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });

  useEffect(() => {
    setExObject({
      expertID: expert_id,
      expertName: expert_Name,
      expertLink: expert_link,
      expertEmail: expert_email,
    });
  }, [expert_id, expert_Name, expert_link, expert_email]);

  const updateHandler = (e) => {
    e.preventDefault();
    setShowEditPopup(false);
    setLoadingPopup(true);
    // console.log(exObject);
    const url = `${API_URL}update-profile-basic`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(exObject),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoadingPopup(false);
        if (data.status === "success") {
          updateProfileData(exObject);
          Swal.fire({
            icon: "success",
            title: "Profile has been updated!",
            showConfirmButton: false,
            timer: 1500,
          });
          setBackupData(
            backupData.map((item) => {
              if (item.id === expert_id) {
                item.name = exObject.expertName;
                item.link = exObject.expertLink;
                item.email = exObject.expertEmail;
              }
              return item;
            })
          );
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        }
      })
      .catch((err) => {
        setLoadingPopup(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  };

  return (
    <>
      <i
        className="fa-regular fa-pen-to-square prjdetails-edit-icon"
        title="Edit profile"
        onClick={() => setShowEditPopup(true)}
      />
      {showEditPopup && (
        <div className="prjdetails-conEdit-popup-wrapper">
          <div className="tab-pane fade show prjdetails-conEdit-div">
            <h4 style={{ marginBottom: "20px" }}>Edit Information</h4>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Expert Name</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.expertName}
                    onChange={(e) => {
                      setExObject({ ...exObject, expertName: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Linkedin Profile</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.expertLink}
                    onChange={(e) => {
                      setExObject({ ...exObject, expertLink: e.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fontWeight500">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    style={{ width: "100%" }}
                    value={exObject.expertEmail}
                    onChange={(e) => {
                      setExObject({ ...exObject, expertEmail: e.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              <center>
                <button
                  type="button"
                  className="btn btn-light prjdetails-editCancel"
                  onClick={() => setShowEditPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn base-btn"
                  style={{ marginLeft: "6px" }}
                  onClick={updateHandler}
                >
                  Update
                </button>
              </center>
            </div>
          </div>
        </div>
      )}

      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>
                Updating data. Please wait . . .
              </p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
